
































import {Component, Prop, Vue} from "vue-property-decorator";
import AgoraRTC, {ILocalAudioTrack, ILocalVideoTrack} from "agora-rtc-sdk-ng";
import {DeviceApplyParams} from "@share/web-conferences/types/DeviceApplyParams";
import TimesIcon from '../../../../assets/svg/web-conferences/times.svg';
import {releaseTrack} from '../../helpers/TracksHelper';

@Component({
  name: "DeviceSelector",
  components: { TimesIcon }
})
export default class DeviceSelector extends Vue {
  @Prop() audioDevices: MediaDeviceInfo[];
  @Prop() videoDevices: MediaDeviceInfo[];
  @Prop() selectedAudioDeviceId: string;
  @Prop() selectedVideoDeviceId: string;

  audioDeviceId = '';
  videoDeviceId = '';

  videoTrack: ILocalVideoTrack | null = null;
  audioTrack: ILocalAudioTrack | null = null;

  async mounted() {
    this.audioDeviceId = this.selectedAudioDeviceId;
    this.videoDeviceId = this.selectedVideoDeviceId;

    [this.videoTrack, this.audioTrack] = await Promise.all([
      AgoraRTC.createCameraVideoTrack({ cameraId: this.videoDeviceId }),
      AgoraRTC.createMicrophoneAudioTrack({ microphoneId: this.audioDeviceId }),
    ]);

    this.playVideoTrack();
  }

  playVideoTrack() {
    if (this.videoTrack) {
      this.videoTrack.play(this.$refs['video'] as HTMLElement);
    }
  }

  async onVideoDeviceChange() {
    if (this.videoTrack) {
      releaseTrack(this.videoTrack);
    }

    this.videoTrack = await AgoraRTC.createCameraVideoTrack({ cameraId: this.videoDeviceId });
    this.playVideoTrack();
  }

  async onAudioDeviceChange() {
    if (this.audioTrack) {
      releaseTrack(this.audioTrack);
    }
    this.audioTrack = await AgoraRTC.createMicrophoneAudioTrack({ microphoneId: this.audioDeviceId });
  }

  apply() {
    this.videoTrack?.stop();
    this.audioTrack?.stop();
    this.$emit('apply', {
      audioDeviceId: this.audioDeviceId,
      videoDeviceId: this.videoDeviceId,
      audioTrack: this.audioTrack,
      videoTrack: this.videoTrack
    } as DeviceApplyParams);
  }

  close() {
    releaseTrack(this.videoTrack);
    releaseTrack(this.audioTrack);
    this.$emit('close');
  }

  get selectedAudioDeviceLabel() {
    return this.audioDevices?.find(audioDevice => audioDevice.deviceId === this.audioDeviceId)?.label;
  }

  get selectedVideoDeviceLabel() {
    return this.videoDevices?.find(videoDevice => videoDevice.deviceId === this.videoDeviceId)?.label;
  }
}
